import {Injectable} from '@angular/core';

import { LocalStorageService } from 'ng2-webstorage';
import { API } from '../api.constants';

import { SystemSetting } from './system-setting.model';
import { HttpClient, HttpResponse} from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ConfigService } from 'src/assets/environments/ConfigService';
@Injectable()
export class SystemSettingStorageService {

    private resourceUrl = API.host +'InvoicePortal/InvoicePortal-systemSettings'; 

    constructor(
        private http: HttpClient,
        private $localStorage: LocalStorageService,
        private config: ConfigService
    ) {}

    getSystemSetting(){
        // get SystemSetting lưu từ LocalStorage, nếu không có thì get từ DB 
        var jsonInfo = this.$localStorage.retrieve('systemSettingInfo')

        if (!jsonInfo){
            this.getDBAndStoreSystemSetting()
            jsonInfo = this.$localStorage.retrieve('systemSettingInfo')
        }

        if (jsonInfo){
            return JSON.parse(jsonInfo);
        }
        
        return new SystemSetting();
    }

    getSystemSettingByCompanyID(companyID: number){
        var jsonInfo = this.$localStorage.retrieve('systemSettingInfo')
        if (!jsonInfo){
            this.getDBAndStoreSystemSettingByCompanyID(companyID)
            jsonInfo = this.$localStorage.retrieve('systemSettingInfo')
        }

        if (jsonInfo){
            return JSON.parse(jsonInfo);
        }
        
        return new SystemSetting();
    }

    clearSystemSetting(){
        this.$localStorage.clear('systemSettingInfo');
    }

    observStoreSystemSetting(){
        const companyID = this.loadconfigCompany();
        return this.http.get(`${this.resourceUrl}/${companyID}`).pipe(map((res: HttpResponse<any>) => {
           this.clearSystemSetting();
            this.storeSystemSetting(res);
            return res;
        }));

    }

    observStoreSystemSettingByCompanyID(companyID: number){
        return this.http.get(`${this.resourceUrl}/${companyID}`).pipe(map((res: HttpResponse<any>) => {
           this.clearSystemSetting();
            this.storeSystemSetting(res);
            return res;
        }));
    }

    loadconfigCompany()
    {
      return this.config.getApi('COMPANYID');
    }
    

    private getDBAndStoreSystemSetting() {
        var systemSetting = this.observStoreSystemSetting();

        systemSetting.subscribe(
            (item) => {
                // this.storeSystemSetting(item);
            }
        )
    }

    private getDBAndStoreSystemSettingByCompanyID(companyID: number) {
        var systemSetting = this.observStoreSystemSettingByCompanyID(companyID);
        systemSetting.subscribe(
            (item) => {
                this.storeSystemSetting(item);
            }
        )
    }

    private storeSystemSetting(systemSetting){
        this.$localStorage.store('systemSettingInfo', JSON.stringify(systemSetting));
    }
}
